// Main Styles
import "../css/style.scss"

// Modules
import Slider from "./modules/Slider"
import GrassSelector from "./modules/GrassSelector"
import Courts from "./modules/Courts"
import Popup from "./modules/Popup"

// Instantiate a new object for the modules
const slider = new Slider()
const grassSelector = new GrassSelector()
const court = new Courts()
const popup = new Popup()